import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FeatureFlagGuard } from '../core/features/feature-flag.guard';
import { FEATURE_FLAGS } from '../data/models/models';
import { TransactionHistoryPage } from './transaction-history.page';


const routes: Routes = [
  {
    path: '',
    component: TransactionHistoryPage,
    canActivate: [FeatureFlagGuard],
    data: { feature: FEATURE_FLAGS.SALES_HISTORY },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TransactionHistoryRoutingModule { }
